<div class="overlay" (click)="$event.stopPropagation()" *ngIf="isShowing">
  <div class="modal">
    <div *ngIf="modal.hasCloseButton" class="modal-close-btn" (click)="cancel(); $event.stopPropagation()">
      <svg class="em-c-icon em-c-icon--large">
        <use xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="../../assets/unity-1.3.0/images/24/em-icons.svg#x-filled"></use>
      </svg>
    </div>
    <div class="modal-title">{{ modal?.title }}</div>

    <div class="modal-body">
      <div class="modal-body__message" *ngFor="let section of modal?.bodySections">
        <h3 *ngIf="section.sectionHeader">{{ section.sectionHeader }}</h3>
        <div *ngIf="section.sectionText">{{ section.sectionText }}</div>
      </div>
      <div *ngIf="modal.hasConfirmButton || modal.hasCancelButton" class="em-c-btn-group ">
        <button *ngIf="modal.hasConfirmButton" type="submit" class="em-c-btn em-c-btn--primary"
          [class.em-c-btn--spinner]="saving" [disabled]="saving" (click)="confirm(); $event.stopPropagation()">
          <span class="em-c-btn__text">{{ modal?.confirmText || "Confirm" }}</span>
        </button>
        <!-- end em-c-btn -->
        <button *ngIf="modal.hasCancelButton" class="em-c-btn em-c-btn--secondary"
          (click)="cancel(); $event.stopPropagation()" [disabled]="saving" [class.em-c-btn--disabled]="saving">
          <span class="em-c-btn__text">{{ modal?.cancelText || "Cancel" }}</span>
        </button>
        <!-- end em-c-btn -->
      </div>
    </div>
    <!-- end of body -->
  </div>
</div>